import { render, staticRenderFns } from "./ConfirmParticipantBan.vue?vue&type=template&id=bcf95eaa&"
import script from "./ConfirmParticipantBan.vue?vue&type=script&lang=js&"
export * from "./ConfirmParticipantBan.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmParticipantBan.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports